import { PLINKO_GAME_LIGHTNING_BOARD, PLINKO_GAME_LIVE_BETS } from 'socket-resources/event-constants/pyramid-plinko-game/index'
import { PLINKO_GAME } from 'socket-resources/namespaces/index'
import useGameSocketNameSpace from 'socket-resources/hooks/useGameSocketNameSpace'

/**
 * Plinko game socket. Connection is handled by useGameSocketNamespace;
 * this hook only exposes the plinko-specific event listeners.
 */
const usePlinkoGameSocketNameSpace = () => {
  const { on, off } = useGameSocketNameSpace(PLINKO_GAME)

  const listenLightningBoardDetails = (cb) => on(PLINKO_GAME_LIGHTNING_BOARD, cb)

  const removeListenLightningBoardDetails = () => off(PLINKO_GAME_LIGHTNING_BOARD)

  const listenLiveBets = (cb) => on(PLINKO_GAME_LIVE_BETS, cb)

  return {
    listenLightningBoardDetails,
    removeListenLightningBoardDetails,
    listenLiveBets
  }
}

export default usePlinkoGameSocketNameSpace
